import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function WelcomePage() {
  const navigate = useNavigate();
  const [link, setLink] = useState("");
  const [error, setError] = useState("");

  function handleGo() {
    setError("");
    const trimmed = link.trim();
    if (!trimmed) return;

    // Accept a full URL like https://ai.checkcells.com/r/TOKEN or just the token
    const match = trimmed.match(/\/r\/([A-Za-z0-9_-]+)/);
    if (match) {
      navigate(`/r/${match[1]}`);
      return;
    }
    // Bare token (no slashes, URL-safe base64 chars)
    if (/^[A-Za-z0-9_-]{20,}$/.test(trimmed)) {
      navigate(`/r/${trimmed}`);
      return;
    }
    setError("That doesn't look like a valid report link.");
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-surface px-6">
      <div className="w-full max-w-md text-center">
        <img
          src="/logo.png"
          alt="CheckCells"
          className="mx-auto mb-6 size-16"
        />
        <h1 className="text-2xl font-bold tracking-tight text-navy">
          CheckCells Companion
        </h1>
        <p className="mx-auto mt-3 max-w-xs text-sm leading-relaxed text-muted">
          Your personal guide to understanding your semen analysis results.
        </p>

        <div className="mx-auto mt-10 flex max-w-sm flex-col gap-6">
          {/* Option 1: QR */}
          <div className="rounded-2xl border border-slate-200 bg-white px-6 py-6 shadow-sm">
            <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-2xl bg-green/10">
              <img src="/qr-code.svg" alt="" className="size-8" />
            </div>
            <h2 className="text-base font-semibold text-navy">
              Scan your QR code
            </h2>
            <p className="mt-1.5 text-sm leading-relaxed text-muted">
              Open your phone's camera and point it at the QR code on your
              printed test report.
            </p>
          </div>

          <div className="flex items-center gap-3">
            <div className="h-px flex-1 bg-slate-200" />
            <span className="text-xs font-medium uppercase tracking-wide text-slate-400">
              or
            </span>
            <div className="h-px flex-1 bg-slate-200" />
          </div>

          {/* Option 2: Paste link */}
          <div className="rounded-2xl border border-slate-200 bg-white px-6 py-6 shadow-sm">
            <h2 className="text-base font-semibold text-navy">
              Paste your report link
            </h2>
            <p className="mt-1.5 text-sm leading-relaxed text-muted">
              Copy the link from your report and paste it below.
            </p>
            <div className="mt-4 flex gap-2">
              <input
                type="text"
                value={link}
                onChange={(e) => { setLink(e.target.value); setError(""); }}
                onKeyDown={(e) => e.key === "Enter" && handleGo()}
                placeholder="Paste link here…"
                className="min-h-[44px] flex-1 rounded-xl border border-slate-200 bg-surface px-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-navy focus:outline-none"
              />
              <button
                type="button"
                onClick={handleGo}
                className="min-h-[44px] rounded-xl bg-navy px-5 text-sm font-semibold text-white transition hover:bg-navy-hover"
              >
                Go
              </button>
            </div>
            {error && (
              <p className="mt-2 text-xs text-red-500">{error}</p>
            )}
          </div>
        </div>

        <p className="mt-8 text-xs text-slate-400">
          Don't have a report yet? Ask your clinic about CheckCells testing.
        </p>
      </div>
    </div>
  );
}
